module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-bcuat-api.rugcc.org/api/v1",
        current_environment : "bcuat"
    }
};